<div class="modal-body text-center m-3">
  <div id="checkin-alert-collect-badge-modal-background" [ngStyle]="{'background-color': color}" class="border border-dark box"></div>
  <h4 id="checkin-alert-collect-badge-modal-warning-text">Please collect your badge.</h4>
  <p id="checkin-alert-collect-badge-modal-remark-text" class="text-title">This badge is valid for the 3 day of conference. Please wear it throughout the conference period.</p>
</div>